import { render } from "./customMessageDialog.vue?vue&type=template&id=52978081&scoped=true"
import script from "./customMessageDialog.vue?vue&type=script&lang=js"
export * from "./customMessageDialog.vue?vue&type=script&lang=js"

import "./customMessageDialog.vue?vue&type=style&index=0&id=52978081&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52978081"]])

export default __exports__